export default [
    {
        name: 'Created',
        value: 't_created',
        datetime: true,
        utc: true
    },
    {
        name: 'Type',
        value: 's_type',
        customWidth: 100
    },
    {
        name: 'Last Status',
        value: 's_status',
        customWidth: 110
    },
    {
        name: 'AWB',
        value: 's_mawb',
        customWidth: 130,
        s_mawb: true
    },
    {
        name: 'Company',
        value: 's_trucking_company'
    },
    {
        name: 'Driver',
        value: 's_trucking_driver'
    },
    {
        name: 'Door',
        value: 's_dock_door',
        customWidth: 75
    }
];